(function (Drupal) {
  Drupal.behaviors.progress_bar = {
    attach: function (context) {
      /**
       * Tracks scroll progress relative to a target element
       * and updates the progress bar width.
       */
      const trackProgress = (targetEl, elProgressPos) => {
        const elementTop = targetEl.getBoundingClientRect().top;
        const elementHeight = targetEl.scrollHeight;
        const viewportHeight = window.innerHeight;

        let progress = ((viewportHeight - elementTop) / elementHeight) * 100;
        progress = Math.min(Math.max(progress, 0), 100);

        elProgressPos.style.width = `${progress}%`;
      };

      /**
       * Initialize the progress bar once.
       */
      context.querySelectorAll('.progress-bar-container').forEach((elProgressBar) => {
        // Prevent re-attaching if Drupal re-renders this region
        if (elProgressBar.dataset.progressBarAttached) return;
        elProgressBar.dataset.progressBarAttached = 'true';

        const elProgressPos = elProgressBar.querySelector('.progress-bar');
        if (!elProgressPos) return;

        const targetEl = document.querySelector(
          `.node__content > section.lb-section--large:first-of-type,
           .node__content > .lb-section:first-of-type:not(.lb-section--large) + section.lb-section--large`
        );
        if (!targetEl) return;

        // Initialize and bind scroll tracking
        trackProgress(targetEl, elProgressPos);
        window.addEventListener('scroll', () => trackProgress(targetEl, elProgressPos));
      });
    }
  };
})(Drupal);
